export default "__VITE_ASSET__DIo7C0Oo__"